import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";
import { useEffect, useMemo } from "react";
import { Field } from "react-final-form";
import { FIELD_TYPES, useFormContext } from "../../../context/FormContext";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import RffInputWrapper from "../shared/RffInputWrapper";

const RffBooleanCheckbox = ({
  name,
  label,
  required = false,
  suppressGrid,
  onChange,
  size,
  helperText,
  sx,
}) => {
  const { registerFieldType } = useFormContext();

  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required]
  );

  useEffect(() => {
    if (name) {
      registerFieldType(name, FIELD_TYPES.BOOLEAN_CHECKBOX);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    <RffInputWrapper
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => {
          const checked = isBoolean(input.value) ? input.value : false;

          return (
            <>
              <FormControlLabel
                sx={{
                  span: {
                    fontSize: "13px !important",
                  },
                  ...sx,
                }}
                control={
                  <Checkbox
                    size="small"
                    checked={checked}
                    onChange={(event) => {
                      const nextValue = event.target.checked;
                      input.onChange(nextValue);
                      if (isFunction(onChange)) {
                        onChange(nextValue);
                      }
                    }}
                    data-type={FIELD_TYPES.BOOLEAN_CHECKBOX}
                  />
                }
                label={label}
              />
              {meta.touched && meta.error && (
                <FormHelperText sx={{ ml: 3 }} error>
                  {meta.error}
                </FormHelperText>
              )}
            </>
          );
        }}
      />
    </RffInputWrapper>
  );
};

export default RffBooleanCheckbox;
